/**
 * setupEvents binds UI interactions to game commands.
 * @param {Object} ui - Map of DOM elements.
 * @param {Object} actions - Map of game action functions and managers.
 */
export function setupEvents(ui, actions) {
    if (!ui || !actions) return;

    // --- Main Menu Actions ---
    ui.runGuardDirect?.addEventListener('click', () => {
        actions.startSpecialtyGuard('General');
    });
    ui.runGuard?.addEventListener('click', () => actions.startGuard());
    ui.runLibrary?.addEventListener('click', () => actions.startLibrary());
    ui.runSimulation?.addEventListener('click', () => actions.startSimulation());
    
    // --- Scene Navigation ---
    document.getElementById('scene-back')?.addEventListener('click', () => {
        if (actions.goBack) actions.goBack();
    });
    document.getElementById('report-back-btn')?.addEventListener('click', () => {
        if (actions.goBack) actions.goBack();
    });

    // --- Day Loop ---
    document.getElementById('btn-end-day')?.addEventListener('click', () => {
        if (actions.endDay) actions.endDay();
    });
    document.getElementById('eod-continue-btn')?.addEventListener('click', () => {
        if (actions.startNewDay) actions.startNewDay();
    });

    // --- Clinical Hub & Navigation ---
    ui.hudBtnHub?.addEventListener('click', () => actions.openHub());
    ui.menuBtnHub?.addEventListener('click', () => actions.openHub());
    ui.btnAtlas?.addEventListener('click', () => actions.openHub('tab-atlas'));
    ui.btnRanking?.addEventListener('click', () => actions.openHub('tab-ranking'));
    ui.btnRounds?.addEventListener('click', () => {
        actions.closeHub(); // Make sure hub is closed
        actions.startRounds();
    });
    ui.closeHub?.addEventListener('click', () => actions.closeHub());

    // --- Talent Tree (Perks) ---
    ui.btnPerks?.addEventListener('click', () => actions.openPerks());
    ui.closePerks?.addEventListener('click', () => actions.closePerks());

    ui.tabBtns?.forEach(btn => {
        btn.addEventListener('click', () => {
            const tabId = btn.dataset.tab;
            if (tabId) actions.openHub(tabId);
        });
    });

    // Modals
    ui.closeCaseSelection?.addEventListener('click', () => actions.closeCaseSelection());

    // --- Guide / Hub Help ---
    ui.helpButton?.addEventListener('click', () => actions.openHub('tab-help'));

    // --- Gacha Lab Actions ---
    ui.pull1?.addEventListener('click', () => actions.pull1());
    ui.pull10?.addEventListener('click', () => actions.pull10());

    // --- Exchange Store Actions ---
    document.getElementById('buy-stamina-btn')?.addEventListener('click', () => {
        actions.buyStamina();
    });
    
    document.querySelectorAll('.exchange-mentor-btn').forEach(btn => {
        btn.addEventListener('click', () => {
            const mentorId = btn.getAttribute('data-mentor');
            if (mentorId) actions.exchangeMentor(mentorId);
        });
    });

    // --- Master Settings Panel Actions ---
    document.getElementById('btn-settings')?.addEventListener('click', () => actions.openSettings());
    document.getElementById('close-settings')?.addEventListener('click', () => actions.closeSettings());
    
    document.getElementById('settings-sfx-toggle')?.addEventListener('change', (e) => {
        actions.toggleSFX(e.target.checked);
    });
    
    document.getElementById('settings-music-toggle')?.addEventListener('change', (e) => {
        actions.toggleMusic(e.target.checked);
    });
    
    document.getElementById('settings-volume-slider')?.addEventListener('input', (e) => {
        const val = parseInt(e.target.value) || 0;
        const display = document.getElementById('settings-volume-value');
        if (display) display.textContent = `${val}%`;
        actions.changeVolume(val / 100);
    });
    
    document.getElementById('settings-reset-btn')?.addEventListener('click', () => {
        actions.resetProgress();
    });

    // --- Global Button SFX (uses actions.playClick defined in main.js) ---
    document.addEventListener('click', (e) => {
        if (e.target.tagName === 'BUTTON' && typeof actions.playClick === 'function') {
            actions.playClick();
        }
    });
}
